/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum RecommendedPagesSpaceBehavior {
  HIDDEN = "HIDDEN",
  SHOWN = "SHOWN",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: EndOfPageRecommendationQuery
// ====================================================

export interface EndOfPageRecommendationQuery_space {
  id: string | null;
}

export interface EndOfPageRecommendationQuery_getRecommendedPages_recommendedPages_content_links {
  webui: string | null;
}

export interface EndOfPageRecommendationQuery_getRecommendedPages_recommendedPages_content_history_ownedBy {
  displayName: string | null;
}

export interface EndOfPageRecommendationQuery_getRecommendedPages_recommendedPages_content_history {
  ownedBy: EndOfPageRecommendationQuery_getRecommendedPages_recommendedPages_content_history_ownedBy | null;
}

export interface EndOfPageRecommendationQuery_getRecommendedPages_recommendedPages_content_space {
  id: string | null;
  key: string | null;
  name: string | null;
}

export interface EndOfPageRecommendationQuery_getRecommendedPages_recommendedPages_content_emoji_nodes {
  id: string | null;
  key: string | null;
  value: string | null;
}

export interface EndOfPageRecommendationQuery_getRecommendedPages_recommendedPages_content_emoji {
  nodes: (EndOfPageRecommendationQuery_getRecommendedPages_recommendedPages_content_emoji_nodes | null)[] | null;
}

export interface EndOfPageRecommendationQuery_getRecommendedPages_recommendedPages_content {
  id: string | null;
  title: string | null;
  type: string | null;
  subType: string | null;
  creatorId: string | null;
  links: EndOfPageRecommendationQuery_getRecommendedPages_recommendedPages_content_links | null;
  history: EndOfPageRecommendationQuery_getRecommendedPages_recommendedPages_content_history | null;
  space: EndOfPageRecommendationQuery_getRecommendedPages_recommendedPages_content_space | null;
  emoji: EndOfPageRecommendationQuery_getRecommendedPages_recommendedPages_content_emoji | null;
}

export interface EndOfPageRecommendationQuery_getRecommendedPages_recommendedPages {
  content: EndOfPageRecommendationQuery_getRecommendedPages_recommendedPages_content;
  strategy: string[];
}

export interface EndOfPageRecommendationQuery_getRecommendedPages_status {
  userCanToggle: boolean;
  isEnabled: boolean;
}

export interface EndOfPageRecommendationQuery_getRecommendedPages {
  recommendedPages: EndOfPageRecommendationQuery_getRecommendedPages_recommendedPages[];
  status: EndOfPageRecommendationQuery_getRecommendedPages_status;
}

export interface EndOfPageRecommendationQuery_getRecommendedPagesSpaceStatus {
  recommendedPagesEnabled: boolean;
  defaultBehavior: RecommendedPagesSpaceBehavior;
}

export interface EndOfPageRecommendationQuery {
  space: EndOfPageRecommendationQuery_space | null;
  getRecommendedPages: EndOfPageRecommendationQuery_getRecommendedPages;
  getRecommendedPagesSpaceStatus: EndOfPageRecommendationQuery_getRecommendedPagesSpaceStatus;
}

export interface EndOfPageRecommendationQueryVariables {
  type: string;
  id: string;
  exp: string;
  key: string;
  keyString: string;
}
